import axios from "axios";

/**
 * True for intentional aborts (React Query cancel, AbortSignal, axios cancel).
 * These must never surface as offline / network toasts.
 */
export function isRequestCanceled(error) {
  if (error == null) return false;
  if (axios.isCancel?.(error) === true) return true;

  if (typeof error === "string") {
    const lower = error.toLowerCase();
    return (
      lower === "canceled" ||
      lower === "cancelled" ||
      lower.includes("request canceled") ||
      lower.includes("request cancelled") ||
      lower.includes("operation canceled") ||
      lower.includes("operation cancelled")
    );
  }

  const code = String(error?.code || "");
  const name = String(error?.name || "");
  const status = String(error?.status ?? "");
  const message = String(error?.message || error?.payload || "").toLowerCase();

  return (
    error?.__CANCEL__ === true ||
    code === "ERR_CANCELED" ||
    name === "CanceledError" ||
    name === "CancelledError" ||
    name === "AbortError" ||
    status === "canceled" ||
    status === "cancelled" ||
    message === "canceled" ||
    message === "cancelled" ||
    message.includes("request canceled") ||
    message.includes("request cancelled") ||
    message.includes("operation canceled") ||
    message.includes("operation cancelled")
  );
}

/**
 * Normalize axios/RTK thunk catch errors for rejectWithValue.
 * Aborts must NOT become status "Network Error" (that triggers offline toasts).
 */
export function toThunkRejectValue(error) {
  if (isRequestCanceled(error)) {
    return {
      message: "canceled",
      status: "canceled",
      data: null,
    };
  }

  return {
    message: error?.message || "Request failed",
    status: error?.response ? error.response.status : "Network Error",
    data: error?.response ? error.response.data : null,
  };
}
